import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {PrinterProjectionDto} from "../../api/ums";
import {ConfigrationPrinterOption} from "../../components/page/ums/UserPrinterConfiguration";

class UmsPrinterStore {

    get data(): PrinterProjectionDto[] {
        return this._data;
    }

    set data(value: PrinterProjectionDto[]) {
        this._data = value;
    }

    get options(): ConfigrationPrinterOption[] {
        return (this.data || []).map(e => ({
            label: `${e.displayName} (${e.name})`,
            id: e.printerId,
            type: e.type
        }))
    }

    private _data: PrinterProjectionDto[] = [];

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const result = await catchApi(async () => await api.ums.api.findPrinters())
        this.data = result?.data || []
    }
}

const umsPrinterStore = new UmsPrinterStore()

export {
    umsPrinterStore
}
